export default __webpack_public_path__ + "static/media/d34.58b9a93c.png";